import React, { FunctionComponent, useState, FC, useEffect } from 'react';
import {useSelector} from 'react-redux';
import { Button, Loader, Icon, Modal, Card, Checkbox } from '@scuf/common';
import {  ERROR_MSG_FOR_USER_RESPONSE,  TRACKING_SUBMIT} from 'src/constants/constants';
import { ICommentModal, IMoreContextModal } from 'src/models/IOpportunitiesAPIModel';
import {  updateComments,  updateMoreContext,  getActionTrackingStatus} from 'src/services/UserAction';
import { getTrainingOptions } from 'src/services/Opportunities';
import { useAppDispatch } from 'src/store';
import { toast, ToastContent, Zoom } from 'react-toastify';
import { Snackbar } from '../../../Snackbar/Snackbar';
import { AcceptToastTransition } from '../../../Toasts/AcceptOppToast';
import {updateActionStatus} from '../../../../slices/opportunitySlice';
import DangerIcon from 'src/images/danger-icon.svg';
import { CompleteTaskFileUpload } from '../../../../components/CompleteTaskFileUpload/CompleteTaskFileUpload';
import { Exception } from 'sass';
import {getCurrentRole} from 'src/slices/onBoardingSlice';
import './CompleteTaskAction.scss';

interface IWarningRenderProps {
  enableHeader?: boolean;
  title?: string;
  headerClass?: string;
  content: string;
  grayBackground?: boolean;
  className?: string;
}

interface TrackingData {
  action_tracking_id: string;
  action_owner_comment: string;
  file_details: any[];
}

interface Task {
  reason_id: string;
  action_type?: string;
  tracking_data: TrackingData[];
}

export const WarnigRender: FC<IWarningRenderProps> = ({ content, enableHeader, title, grayBackground, className }) => {
  return <Card interactive={false}>
    <Card.Header title={title ? title : ''} className={enableHeader ? 'disclaimer-header' : 'disable-disclaimer-header'} />
    <Card.Content className={grayBackground ? 'notify-disclaimer-background' : 'notify-disclaimer'}>
      <div className={className ? className : 'disclaimer-icon'}>
        <img src={DangerIcon} alt="danger icon" />
      </div>
      <div className="para">{content}</div>
    </Card.Content>
  </Card>;
};

interface ICompleteTaskPopup {
  onClose: Function;
  kpiId: number;
  title: string;
  textAreaTitle: string;
  opportunityId: any;
  sendUserResponse?: Function;
  anomaly_id: string;
  orgOwnerId: string;
  opportunityObjectName?: number | undefined;
  sendingMailToatser?: Function;
  insightSummaryDisplayCategory?: string;
  modelId?: number;
}

type ToastType =
  | 'accept'
  | 'reject'
  | 'realize'
  | 'claim-ownerShip'
  | 'more-context'
  | 'tracking-submit';

export const CompleteTaskActionPopup: FunctionComponent<ICompleteTaskPopup> = (props) => {
  const [enableRetryErr, setEnableRetryErr] = useState(false); // flag to enable submit button
  const [acceptActionInProgress, setacceptActionInProgress] = useState(false);
  const dispatch = useAppDispatch();
  const [errorMessage, setErrorMessage] = useState('');
  const [errorMessageFlag, setErrorMessageFlag] = useState(false);
  const [btnText, setBtnText] = useState('Complete');
  const [, setIsButtonLoading] = useState(false);
  const [loader, setLoader] = useState(true);
  const [isCompleteTask, setCompleteTask] = useState(false);
  const [taskData, setTaskData] = useState([]);
  const currentRole = useSelector(getCurrentRole);
  // const [saveBtnStatus, setSaveBtnStatus] = useState(false);
  const [checkBoxStatus, setCheckBoxStatus] = useState(false);
  const [trainingOptions, setTrainingOptions] = useState([] as any);
  useEffect(() => {
    getActionTracking(props.opportunityId);
  }, []);

  useEffect(() => {
    getTrainingOptions()
      .then((response: any) => {
        setTrainingOptions(response || []);
      })
      .catch(() => {
        setTrainingOptions([]);
      });
  }, []);

  // const getActionTracking = (id: number) => {
  //   dispatch(getActionTrackingStatus(id,currentRole)).then((response: any) => {
  //     setTaskData(response);
  //     setLoader(false);
  //   }).catch((e: Exception) => setLoader(false));
  // }


// const handleTaskCheckbox = () => {
//     const status = false; // Explicitly set status to false
//     setSaveBtnStatus(status); // Update the state with false
//     console.log("Checkbox status set to:", status);
// };

  const getActionTracking = (id: number) => {
    dispatch(getActionTrackingStatus(id,currentRole)).then((response: any) => {
      setTaskData(response);
      validateInitialTasks(response);
      setLoader(false);
    }).catch((e: Exception) => setLoader(false));
  }

  const validateInitialTasks = (tasks: Task[]) => {
    if (!Array.isArray(tasks) || tasks.length === 0) {
      setCheckBoxStatus(false);
      return;
    }

    const allTasksValid = tasks.every(task => {
      if (!task?.reason_id || !Array.isArray(task?.tracking_data)) {
        return false;
      }

      return task.tracking_data.every(tracking => {
        const isValid = Boolean(
          tracking?.action_tracking_id &&
          tracking?.action_owner_comment?.trim() &&
          Array.isArray(tracking?.file_details) &&
          tracking.file_details.length > 0
        );

        return isValid
      });
    });

    setCheckBoxStatus(allTasksValid);
  };

  const handleTaskCompletion = (isValid: boolean) => {
    setCheckBoxStatus(isValid);
  };

  const postActionResponse = (status: string) => {
    if (status === 'success') {
      getActionTracking(props.opportunityId);
      showActionToast(
        <Snackbar toastMessage="Task saved successfully." />,
        'tracking-submit'
      );
    } else {
      showActionToast(
        <Snackbar toastMessage="There is an issue, please try again" />,
        'reject'
      );
      props.onClose();
    }
  }

  const showActionToast = (toastContent: ToastContent, type: ToastType) => {
    if (type === 'reject' || type === 'realize') {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'accept') {
      toast(toastContent, {
        className: 'fi-toast--accept',
        bodyClassName: 'fi-toast__body--accept',
        transition: AcceptToastTransition,
        closeOnClick: true,
      });
    } else if (type === 'more-context') {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'claim-ownerShip') {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'tracking-submit') {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    }
  };

  const notifyOrgUser = () => {
    setIsButtonLoading(true);
    setEnableRetryErr(false);
    setBtnText('Submitting...');
    setacceptActionInProgress(true);
    const data: ICommentModal = {
      user_comment: '',
      type: TRACKING_SUBMIT,
    }; // @ts-ignore

    dispatch(updateComments(props.opportunityId, data))
      .then(() => {
        setacceptActionInProgress(false);
        let data: IMoreContextModal = {
          shareTo: [props.orgOwnerId],
          comment: '',
          anomaly_id: props.anomaly_id,
          type: TRACKING_SUBMIT
        }; // @ts-ignore
        dispatch(updateActionStatus())
        dispatch(updateMoreContext(props.opportunityId, data)).then((response: any) => {
            });
        showActionToast(
          <Snackbar toastMessage="Task submitted successfully." />,
          'tracking-submit'
        );
        props.onClose();
      })
      .catch((error: any) => {
        setErrorMessage('Error');
        setErrorMessageFlag(true);
        setEnableRetryErr(true);
        setacceptActionInProgress(false);
        setBtnText('Retry');
      });
  };

  // const handleTaskCheckbox = (status: boolean) => {
  //   setSaveBtnStatus(status);
  //   setCheckBoxStatus(status);
  //   console.log("Checkbox status set to:", status);
  //   return status;
  // }

  return (
    <>
      <Modal.Header className="disclaimer-title" >Actions requested by Organization Owner</Modal.Header>
      {loader ? (
        <Loader
          loading={loader}
          text="Fetching activity log..."
          minHeight="28vh"
          max-height="70vh"
          overlayColor="transparent"
        />
      ) : <>
        <Modal.Content>
          {taskData?.map((item: any, index: any) => {
            return (
              <div key={`action-task-${item.reason_id}-${index}`}>
                <div className='complete-task-title'>{`${index + 1}. ${item.reason}`}</div>
                {
                  item.tracking_data.map((data: any) => {
                    return (
                      <CompleteTaskFileUpload
                        action_tracking_id={data.action_tracking_id}
                        status={data.status}
                        org_owner_remarks={data.org_owner_remarks}
                        target_date={data.target_date}
                        postActionResponse={postActionResponse}
                        action_owner_comment={data.action_owner_comment}
                        file_details={data.file_details} 
                        reasonId={item.reason_id}
                        handleTaskCheckbox={handleTaskCompletion}
                        trainingOptions={trainingOptions}
                        training_name={data.training_name}
                        modelId={props.modelId}
                        insightSummaryDisplayCategory={props.insightSummaryDisplayCategory}
                        actionType={item.action_type}
                        key={`action-item-${data.action_tracking_id}-${data.action_owner_id}`} />
                    );
                  })
                }
              </div>
            );
          })}
        </Modal.Content>

        <Modal.Footer className="disclaimer-footer">

          {enableRetryErr && errorMessage.length === 0 && (
            <div className="getMorePopup__footer--err">
              {ERROR_MSG_FOR_USER_RESPONSE}
            </div>
          )}
          {errorMessageFlag && errorMessage.length > 0 && (
            <div className="getMorePopup__footer--err">{errorMessage}</div>
          )}
          <Checkbox
            className="checkbox-fi"
            data-testid='cb-reason1'
            label="Task Completed"
            checked={isCompleteTask}
            disabled={!checkBoxStatus}
            onChange={(checked) => { setCompleteTask(checked); }}
          />
        <Button
            className="button--secondary button-space"
            data-testid="cancel"
            size="small"
            type="secondary"
            disabled={acceptActionInProgress}
            onClick={() => {
              props.onClose();
            }}
            content="Cancel"
          />
          <Button
            className={`button--primary button-space ${acceptActionInProgress
              ? 'accept-popup__footer--readonly btn-loading'
              : ''
              }`}
            size="small"
            icon={
              enableRetryErr ? (
                <Icon
                  root="building"
                  name="refresh"
                  exactSize={22}
                  className="accept-popup__footer--retry"
                />
              ) : (
                ''
              )
            }
            iconPosition="right"
            disabled={isCompleteTask ? false : true}
            type="primary"
            data-testid="submit"
            onClick={notifyOrgUser}
            content={btnText}
          />
        </Modal.Footer></>}
    </>
  );
};
